import React, {Component} from 'react'
import Typed from 'typed.js'

export default class Typer extends Component {

    componentDidMount() {
        const options = {
            strings: [
                'coffee',
                'restroom',
                'gate A12',
                'headphones',
                'ticket counter',
                'security',
                'candy',
                'television',
                'aspirin',
                'restaurant',
                'healthy snack',
                'baby formula',
                "women's clothing",
                'baggage claim',
            ],
            typeSpeed: 70,
            backDelay: 4000,
            loop: false,
            loopCount: false,
        }

        new Typed('#automatic-input-typewriter', options)
    }

    render() {
        return (
            <form action="#" className="search-form" data-bottom-top="transform:translate(-50%, 200px) scale(0)" data-center-top="transform:translate(-50%, 0) scale(1);">
                <div className="input-wrap">
                    <input id="automatic-input-typewriter" type="search" placeholder="Search DWA for anything..."/>
                    <button type="submit" className="btn-search">
                        <i className="icon-search" />
                    </button>
                </div>
            </form>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/Typer.js